var _g;
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLink(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Link"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M5.73306 7.5013C5.32328 7.47723 4.91304 7.54001 4.52922 7.68554C4.1454 7.83106 3.79665 8.05604 3.50583 8.34573L2.81443 9.03713C2.26432 9.58724 1.95527 10.3334 1.95527 11.1113C1.95527 11.8893 2.26432 12.6354 2.81443 13.1855C3.36455 13.7356 4.11066 14.0447 4.88863 14.0447C5.66661 14.0447 6.41272 13.7356 6.96283 13.1855L7.65423 12.4941C7.94379 12.2032 8.16868 11.8545 8.31419 11.4707C8.45971 11.0869 8.52257 10.6767 8.49866 10.2669",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M7.50121 5.73339C7.4771 5.32361 7.53987 4.91336 7.68539 4.52953C7.83092 4.1457 8.05592 3.79696 8.34564 3.50616L9.03704 2.81476C9.58716 2.26465 10.3333 1.9556 11.1112 1.9556C11.8892 1.9556 12.6353 2.26465 13.1854 2.81476C13.7356 3.36488 14.0446 4.11099 14.0446 4.88896C14.0446 5.66694 13.7356 6.41305 13.1854 6.96316L12.494 7.65456C12.2032 7.94419 11.8544 8.16912 11.4706 8.31464C11.0868 8.46016 10.6766 8.52298 10.2668 8.49899",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M5.57935 10.4199L10.4191 5.58012",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLink);
export default __webpack_public_path__ + "static/media/Link.b0b8aab7.svg";
export { ForwardRef as ReactComponent };